/* eslint-disable */
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@capacitor/google-maps';
import { MapPadding } from '@capacitor/google-maps/dist/typings/definitions';
import { Subscription } from 'rxjs';
import { msMapTypeToMapType } from 'src/app/utils/google-map/google-map.utils';
import { GoogleMapsState } from './google-maps.state';
import { GoogleMapsViewModelFactory } from './google-maps.view-model.factory';
import { GoogleMapsConfig } from './models/google-maps.config';

const MAP_LOAD_DELAY = 1000;
@Component({
  selector: 'google-map',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss']
})
export class GoogleMapsComponent {
  @ViewChild('map') private mapRef: ElementRef<HTMLElement>;
  @Output() stateChangeEvent = new EventEmitter<GoogleMapsState.Spec>();

  private viewModel = this.viewModelFactory.create();
  private subscriptions: Subscription[] = [];

  constructor(private viewModelFactory: GoogleMapsViewModelFactory) {}

  initiateMap(enableCurrentLocation: boolean) {
    //Delay to avoid race condition between iOS MapViewController.viewDidEnter and Map.setCamera
    setTimeout(async () => {
      await this.viewModel.initiateMap(enableCurrentLocation);
    }, MAP_LOAD_DELAY);
  }

  async tearDown() {
    await this.viewModel.onCleanUp();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  setUp(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    const stateSubscription = this.viewModel.state.subscribe((state) => {
      this.stateChangeEvent.emit(state);
      if (state instanceof GoogleMapsState.Loading) {
        this.initiateMapActual(state.config);
      }
    });
    this.subscriptions.push(stateSubscription);
  }

  private async initiateMapActual(config: GoogleMapsConfig): Promise<void> {
    const mapType = msMapTypeToMapType(config.mapType);
    const padding: MapPadding = {
      top: config.padding,
      left: config.padding,
      right: config.padding,
      bottom: config.padding
    };

    const map = await GoogleMap.create({
      id: 'mapId',
      element: this.mapRef.nativeElement,
      apiKey: config.apiKey,
      forceCreate: true,
      config: {
        width: config.pixelWidth,
        height: config.pixelHeight,
        center: config.center,
        zoom: config.zoom
      }
    });

    await map.setMapType(mapType);
    await map.setPadding(padding);
    await map.enableCurrentLocation(config.enableCurrentLocation);

    this.viewModel.onMapLoaded(map);
  }
}
